import { createContext, useContext, ReactNode } from 'react';
import { useDevicePWAConfig } from '../hooks/useDevicePWAConfig';

export interface DevicePWAConfig {
  id?: string;
  device_id?: string;
  organization_id?: string;
  home_widgets?: Record<string, boolean>;
  home_layout_order?: string[];
  logo_light_url?: string | null;
  logo_dark_url?: string | null;
  welcome_message?: string | null;
  shop_template?: string;
  shop_settings?: Record<string, any>;
  visible_categories?: string[];
  category_order?: string[];
  featured_product_ids?: string[];
  contact_phone?: string | null;
  contact_email?: string | null;
  contact_address?: string | null;
  contact_phone_enabled?: boolean;
  contact_email_enabled?: boolean;
  opening_hours?: Record<string, any> | null;
  opening_hours_enabled?: boolean;
  auth_method?: string | null;
  guest_shopping_enabled?: boolean;
}

interface PWAConfigContextValue {
  config: DevicePWAConfig;
  isLoading: boolean;
  deviceId?: string;
}

const PWAConfigContext = createContext<PWAConfigContextValue | undefined>(undefined);

interface PWAConfigProviderProps {
  children: ReactNode;
  deviceId?: string;
}

export function PWAConfigProvider({ children, deviceId }: PWAConfigProviderProps) {
  const { config, isLoading } = useDevicePWAConfig(deviceId);
  
  return (
    <PWAConfigContext.Provider 
      value={{ 
        config: config || {} as DevicePWAConfig, 
        isLoading,
        deviceId 
      }}
    >
      {children}
    </PWAConfigContext.Provider>
  );
}

export function usePWAConfig() {
  const context = useContext(PWAConfigContext);
  if (!context) {
    throw new Error('usePWAConfig must be used within PWAConfigProvider');
  }
  return context;
}
